import { Form, Formik } from 'formik';
import ModalWindow from '../ModalWindow';
import useValidationSchema from './contactsValidationSchema';
import styles from './CreatingObjectContacts.module.scss';
import { ButtonType, ModalWindowTypes } from '../../../utils/@globalTypes';
import Button from '../../Button';
import ObjectContactsForm from '../../ObjectContactsForm';
import { useDispatch, useSelector } from 'react-redux';
import {
  createSocialNetworkAction,
  getContacts,
  MainObjectSelectors,
  updateObjectContacts,
} from '../../../redux/reducers/mainObjectSlice';
import Loader from '../../Loader';
import {
  CreateSocialNetworkType,
  ObjectContactsFormType,
  SocialNetworks,
  UpdateObjectContactsType,
} from '../../../redux/types/mainObjectTypes';
import SocialNetworkContact from '../../SocialNetworkContact';
import useSocialValidationSchema from './socialValidationSchema';
import { setModalWindowData } from '../../../redux/reducers/pageSlice';

const CreatingObjectContacts = () => {
  const validationSchema = useValidationSchema();
  const socialValidSchema = useSocialValidationSchema();
  const dispatch = useDispatch();
  const contacts = useSelector(MainObjectSelectors.getMainObjectContacts);
  const socialNetworksTypes = useSelector(
    MainObjectSelectors.getSocialNetworksTypes,
  );
  const handlerClose = () => {
     dispatch(setModalWindowData({ type: ModalWindowTypes.CLOSE }));
  }
  const initialLat = contacts?.coordinates?.lat
    ? Number(contacts?.coordinates?.lat).toFixed(6).toString()
    : '';
  const initialLon = contacts?.coordinates?.lon
    ? Number(contacts?.coordinates?.lon).toFixed(6).toString()
    : '';

  const initialValues: ObjectContactsFormType = {
    email: contacts?.email || '',
    phone: {
      country_code: contacts?.phone?.country_code || 'by',
      phone_code: contacts?.phone?.phone_code || '+375',
      phone_number: contacts?.phone?.phone_number || '',
    },
    lat: initialLat,
    lon: initialLon,
  };
  const initialTelegram =
    contacts?.social_networks.filter(
      (item) => item.social_network_type.title === SocialNetworks.TELEGRAM,
    )[0]?.account || '';
  const initialInstagram =
    contacts?.social_networks.filter(
      (item) => item.social_network_type.title === SocialNetworks.INSTAGRAM,
    )[0]?.account || '';
  const initialFacebook =
    contacts?.social_networks.filter(
      (item) => item.social_network_type.title === SocialNetworks.FACEBOOK,
    )[0]?.account || '';
  const initialVkontakte =
    contacts?.social_networks.filter(
      (item) => item.social_network_type.title === SocialNetworks.VK,
    )[0]?.account || '';
  // console.log(initialInstagram)
  const socialInitialValues = {
    telegram: initialTelegram,
    instagram: initialInstagram,
    facebook: initialFacebook,
    vk: initialVkontakte,
    viber: {
      country_code: contacts?.phone?.country_code || 'by',
      phone_code: contacts?.phone?.phone_code || '+375',
      phone_number: contacts?.phone?.phone_number || '',
    },
  };
  const setFieldAction = (fieldName: string, initialValue: any, value: any) => {
    const id =
      socialNetworksTypes.find((item) => item.title === fieldName)?.id || 0;
    if (!initialValue && value && contacts?.id) {
      const data: CreateSocialNetworkType = {
        account: value,
        social_network_type: id,
        main_object_contacts: contacts.id,
      };
      try {
        dispatch(createSocialNetworkAction(data));
      } catch (error) {
        console.error('Ошибка отправки:', error);
      }
    }
  };

  if (!contacts) return <Loader />;
  return (
    <ModalWindow isLoading={false} windowClassname={styles.window} isFullCustom>
      <div className={styles.container}>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          validateOnBlur={false}
          validateOnChange={false}
          validateOnMount={false}
          enableReinitialize={true}
          onSubmit={(values) => {
            const updateContacts: UpdateObjectContactsType = {};
            if (contacts.email !== values.email) {
              updateContacts.email = values.email;
            }
            if (
              JSON.stringify(contacts.phone) !== JSON.stringify(values.phone)
            ) {
              updateContacts.phone = values.phone;
            }
            if (
              initialValues.lat !== values.lat ||
              initialValues.lon !== values.lon
            ) {
              updateContacts.coordinates = {
                lat: values.lat,
                lon: values.lon,
              };
            }
            const keys = Object.keys(updateContacts).length;

            if (keys > 0) {
              try {
                dispatch(
                  updateObjectContacts({
                    id: contacts.id,
                    data: updateContacts,
                  }),
                );
              } catch (error) {
                console.error('Ошибка отправки:', error);
              }
            }
          }}
        >
          {(formik) => (
            <Form>
              <h3 className={styles.title}>Контактные данные</h3>
              <ObjectContactsForm formik={formik} />
              <div
                className={styles.btnFormWrap}
                onClick={(e) => !formik.dirty && e.stopPropagation()}
              >
                <div
                  className={styles.btnSave}
                  onClick={() => !formik.dirty && formik.setSubmitting(false)}
                >
                  <Button
                    title="Сохранить"
                    disabled={
                      !formik.dirty || Object.keys(formik.errors).length > 0
                    }
                    type={ButtonType.PRIMARY_SMALL}
                    actionType="submit"
                  />
                </div>
                <div className={styles.btnCancel}>
                  <Button
                    title="Отмена"
                    type={ButtonType.SECONDARY_SMALL}
                    actionType="reset"
                    onClick={handlerClose}
                  />
                </div>
              </div>
            </Form>
          )}
        </Formik>
        {/* <h3 className={styles.title}>
          Социальные сети
        </h3> */}
        {/* <div>
          <Formik
            initialValues={socialInitialValues}
            validationSchema={socialValidSchema}
            validateOnBlur={false}
            validateOnChange={false}
            validateOnMount={false}
            onSubmit={(values) => {
              console.log(values)
              setFieldAction(SocialNetworks.TELEGRAM, socialInitialValues.telegram, values.telegram)
              setFieldAction(SocialNetworks.INSTAGRAM, socialInitialValues.instagram, values.instagram)
              setFieldAction(SocialNetworks.FACEBOOK, socialInitialValues.facebook, values.facebook)
              setFieldAction(SocialNetworks.VK, socialInitialValues.vk, values.vk)

              dispatch(getContacts(contacts.main_object.id))
            }}
           > */}
        {/* {(formik) => (
          <Form>
            <SocialNetworkContact
              formik={formik}
            />
            <div
                className={styles.btnFormWrap}
                onClick={(e) => !formik.dirty && e.stopPropagation()}
              >
                <div
                  className={styles.btnSave}
                  onClick={() => !formik.dirty && formik.setSubmitting(false)}
                >
                  <Button
                    title="Сохранить"
                    disabled={!formik.dirty}
                    type={ButtonType.PRIMARY_SMALL}
                    actionType="submit"
                  />
                </div>
                <div className={styles.btnCancel}>
                  <Button
                    title="Отмена"
                    type={ButtonType.SECONDARY_SMALL}
                    actionType="reset"
                    onClick={formik.resetForm}
                  />
                </div>
              </div>  
           </Form>
          )} */}
        {/* </Formik> 
        </div> */}
      </div>
    </ModalWindow>
  );
};
export default CreatingObjectContacts;
